"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

interface ConditionalFooterProps {
  children: ReactNode;
  hideOnFeed?: boolean;
}

export default function ConditionalFooter({ children, hideOnFeed = true }: ConditionalFooterProps) {
  const pathname = usePathname() ?? "";
  if (hideOnFeed && pathname === "/feed") {
    return null;
  }
  return <div className="hidden md:block">{children}</div>;
}


